import React from 'react';
import styles from '@components/catalog/sort/sort.module.scss';
import { ElasticSearch } from '@interfaces/models/elasticSearch';

interface SortOptionsListProps {
  selectedValue: ElasticSearch['sortBy'];
  handleChange: (value: ElasticSearch['sortBy']) => void;
  options: {
    text: string;
    value: ElasticSearch['sortBy'];
  }[];
}

const SortOptionsList = ({ options, handleChange, selectedValue }: SortOptionsListProps) => {
  return (
    <>
      {options.map((option) => (
        <div
          key={option.value}
          tabIndex={0}
          role="button"
          className={styles['radio-option']}
          onClick={() => handleChange(option.value)}
          onKeyPress={() => handleChange(option.value)}
        >
          <input
            className={styles['radio-option__input']}
            type="radio"
            value={option.value}
            checked={option.value === selectedValue}
            tabIndex={-1}
            readOnly
            data-cy={`catalog-sort-popup-option-${option.value}`}
          />
          <span>{option.text}</span>
        </div>
      ))}
    </>
  );
};

export default SortOptionsList;
